import config from '../../config';

export default {
  url: `${config.api.baseURL}/forgot-pin`,
  options: {
    method: 'POST'
  },
  transformer(data) {
    return data;
  }
};
